<template>
  <div class="page page__list">
    <scroll-list @refresh="onSearch" @loadpage="onSearch">
      <div
        class="weui-cell weui-cell_access"
        v-for="item in items"
        :key="item.id"
        @click="onSelect(item)"
      >
        <div class="weui-cell__bd">
          <p>{{item.realname}}</p>
        </div>
        <div class="weui-cell__ft">
          <p>{{item.mobile}}</p>
        </div>
      </div>
    </scroll-list>
    <div class="list-footer">
      <label class="list-footer__label">共：{{items.length}}个</label>
    </div>
  </div>
</template>

<script>
import ScrollList from "@/components/ScrollList.vue";

export default {
  components: {
    ScrollList
  },
  data() {
    return {
      items: []
    };
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.onSearch();
    });
  },
  methods: {
    onSearch(callback) {
      var me = this;
      me.$loading({
        url: "/api/account/account/list"
      }).then(function(res) {
        callback && callback.call(me);
        if (res.success) {
          me.items = res.data;
        } else {
          me.$router.push({
            name: "Error",
            params: res
          });
        }
      });
    },
    onSelect() {
      console.log(this.$route);
    }
  }
};
</script>